module.exports = __webpack_public_path__ + "static/media/icon_services_on.a06ad535.png";